import type { GetCoversQuery, GetCoversQueryVariables } from '@/typings/domain'
import apolloClient from './apolloClient'
import GetCoversGQL from './graphql/GetCovers.graphql'

export function getCovers(variables: GetCoversQueryVariables) {
  return apolloClient.query<GetCoversQuery, GetCoversQueryVariables>({
    query: GetCoversGQL,
    variables: {
      ...variables,
      ignorePinning: true,
    },
    fetchPolicy: 'no-cache',
  })
}
